import { FormattedEvent } from '@eventbrite/event-renderer';
import { $FixMe } from '@eventbrite/ts-utils';
import { FunctionComponent } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { trackEnterMapView as trackEnterMapViewAction } from '../../../../redux/actions/analytics';
import { saveEvent } from '../../../../redux/actions/event';
import { getUserCurrentLocation as getUserCurrentLocationAction } from '../../../../redux/actions/location';
import {
    searchByBBox as searchByBBoxAction,
    viewEventMapView as viewEventMapViewAction,
} from '../../../../redux/actions/search';
import {
    setMapPinClickTarget as setMapPinClickTargetAction,
    setMapPinHoverTarget as setMapPinHoverTargetAction,
} from '../../../../redux/actions/ui';
import { DiscoverState } from '../../../../types';
import { SearchResponseEventsData } from '../../../../utils/transformation';
import { SearchMap } from '../../components/SearchMap';

export type MapPanelContainerProps = {
    events: SearchResponseEventsData;
    isLoading: boolean;
    height?: number;
    isFixed?: boolean;
    isMobile?: boolean;
};

const _mapStateToProps = (
    state: DiscoverState,
    { isLoading, events }: MapPanelContainerProps,
) => ({
    events: isLoading ? [] : parseResultsForMap(events),
    domain: state.app.domain,
    countryCode: state.app.countryCode,
    googleMapsApiKey: state.googleMapsApiKey,
    googleMapsLanguage: state.app.googleMapsLanguage,
    currentPlace: state.location.currentPlace,
    currentPlaceParent: state.location.currentPlaceParent,
    latitude: state.location.latitude,
    longitude: state.location.longitude,
    isAuthenticated: state.auth.isAuthenticated,
    searchMapBounds: state.search.eventSearch.bbox,
    featureFlags: state.app.featureFlags,
    hoverEventCardTarget: state.ui.eventHoverTarget,
    isUsingCurrentLocation: state.location.isUsingCurrentLocation,
    selectedPinEvent: state.ui.focusedEventCards[0] ?? undefined,
    userLatLng: state.location.userLatLng,
});

function parseResultsForMap({
    organic,
}: SearchResponseEventsData): FormattedEvent[] {
    // TODO: Include promoted events in Map
    const allEvents = organic;
    return allEvents.filter(
        ({ venue }) => venue?.address.latitude && venue?.address.longitude,
    );
}

const _mapDispatchToProps = (
    dispatch: Function,
    { history }: MapPanelContainerProps & RouteComponentProps,
) => ({
    searchByBBox: (...args: any) =>
        dispatch(searchByBBoxAction(history, ...args)),
    enterMapView: () => dispatch(trackEnterMapViewAction()),
    viewEventMapView: (...args: [$FixMe]) =>
        dispatch(viewEventMapViewAction(...args)),
    setMapPinHoverTarget: (eventIds: string[]) =>
        dispatch(setMapPinHoverTargetAction(eventIds)),
    setMapPinClickTarget: (eventIds: string[]) =>
        dispatch(setMapPinClickTargetAction(eventIds)),
    handleUseCurrentLocation: () =>
        dispatch(getUserCurrentLocationAction(history, false, true)),
    onSaveEvent: (...args: [$FixMe]) => dispatch(saveEvent(...args, true)),
});

export const MapPanelContainer: FunctionComponent<MapPanelContainerProps> =
    compose<$FixMe>(
        withRouter,
        connect(_mapStateToProps, _mapDispatchToProps),
    )(SearchMap);
